import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FormGroup, FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { BaseChartDirective } from 'ng2-charts';
import { TranslateService } from '@ngx-translate/core';
import { CacheService } from './_services/cache.service';
import { IdleService } from './_services/idle.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  currentLanguageImage: string;
  languageList = [
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Spanish' },
  ];

  public constructor(
    private titleService: Title,
    public translate: TranslateService,
    public cacheService: CacheService,
    private idleService: IdleService
  ) {
    translate.setDefaultLang('es');
    translate.addLangs(['en', 'es']);
    translate.use(this.cacheService.get('lang') || 'es');
    this.cacheService.setLang(this.cacheService.get('lang') || 'es');
  }

  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;
  public someAction(): void {
    this.chart?.toBase64Image();
  }

  ngOnInit() {
    this.setCurrentLanguageImage();
    this.idleService.startWatching();
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(environment.projectName);
  }

  public validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  public UTCToLocalTime(utc) {
    const date = new Date(utc);
    return new Date(date + ' UTC').toLocaleString();
  }

  changeSiteLanguage(localeCode: string): void {
    const selectedLanguage = this.languageList
      .find((language) => language.code === localeCode)
      ?.label.toString();
    if (selectedLanguage) {
      this.translate.use(localeCode);
      this.cacheService.setLang(localeCode);
    }
    const currentLanguage = this.translate.currentLang;
    this.setCurrentLanguageImage();
  }

  setCurrentLanguageImage() {
    if (this.translate.currentLang === 'es') {
      this.currentLanguageImage = 'assets/img/flag/spain-flag.png';
    } else if (this.translate.currentLang === 'en') {
      this.currentLanguageImage = 'assets/img/flag/usa-flag.png';
    }
  }
}
